/**
 * Projects resource - /api/projects endpoints
 */
import { getLogger } from '@qwickapps/logging';
const log = getLogger('QwickForge.MiddlewareClient.ProjectsResource');
export class ProjectsResource {
    http;
    constructor(http) {
        this.http = http;
    }
    /**
     * List all projects
     */
    async list() {
        log.debug('Listing projects');
        try {
            const projects = await this.http.get('/api/projects');
            log.debug('Projects listed', { count: projects.length });
            return projects;
        }
        catch (error) {
            log.error('Failed to list projects', {
                error: error instanceof Error ? error.message : String(error),
            });
            return [];
        }
    }
    /**
     * Get project by ID
     */
    async get(projectId) {
        try {
            log.debug('Getting project', { projectId });
            const project = await this.http.get(`/api/projects/${projectId}`);
            return project;
        }
        catch (error) {
            if (error.statusCode === 404) {
                log.debug('Project not found', { projectId });
                return undefined;
            }
            throw error;
        }
    }
    /**
     * Create a new project
     */
    async create(data) {
        log.debug('Creating project', { name: data.name });
        // Generate slug from name if not provided
        const slug = data.name
            .toLowerCase()
            .replace(/[^a-z0-9]+/g, '-')
            .replace(/^-+|-+$/g, '');
        const response = await this.http.post('/api/projects', {
            ...data,
            slug,
        });
        log.info('Project created', { projectId: response.id, name: data.name });
        return response;
    }
    /**
     * Update project current directory
     */
    async updateCurrentDir(projectId, currentDir) {
        log.debug('Updating project current directory', { projectId, currentDir });
        await this.http.patch(`/api/projects/${projectId}`, { currentDir });
        log.debug('Project current directory updated', { projectId, currentDir });
    }
    /**
     * Update project
     */
    async update(projectId, data) {
        log.debug('Updating project', { projectId });
        const response = await this.http.patch(`/api/projects/${projectId}`, data);
        log.debug('Project updated', { projectId });
        return response;
    }
    /**
     * Delete a project (hard delete - use softDelete instead)
     */
    async delete(projectId) {
        log.debug('Deleting project', { projectId });
        await this.http.delete(`/api/projects/${projectId}`);
        log.info('Project deleted', { projectId });
    }
    /**
     * Soft delete a project (move to trash)
     */
    async softDelete(projectId) {
        log.debug('Soft deleting project', { projectId });
        await this.http.patch(`/api/projects/${projectId}/trash`, {});
        log.info('Project moved to trash', { projectId });
    }
    /**
     * Restore a project from trash
     */
    async restore(projectId) {
        log.debug('Restoring project', { projectId });
        await this.http.patch(`/api/projects/${projectId}/restore`, {});
        log.info('Project restored', { projectId });
    }
    /**
     * Permanently delete a project with reason
     */
    async permanentDelete(projectId, reason) {
        log.debug('Permanently deleting project', { projectId });
        await this.http.post(`/api/projects/${projectId}/permanent-delete`, { reason });
        log.info('Project permanently deleted', { projectId });
    }
}
//# sourceMappingURL=ProjectsResource.js.map